import { render, staticRenderFns } from "./icon_mdi_file_document_multiple.vue?vue&type=template&id=bebc2786"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports